import React from "react";
import ReactDOM from "react-dom/client";
import Chatbot from "./js/chatbot";
import OTPBehaviour from "./js/otp";
import RoleHighlightBehaviour from "./js/role";
import SteppersBehaviour from "./js/steppers";
import SignupButtonBehaviour from "./js/signup";
import TogglePasswordBehaviour from "./js/login";
import ExcludeBehaviour from "./js/exclude";
import PaymentForm from "./js/payment";

const rootElement = document.getElementById("react-root");
if (rootElement) {
const otp = rootElement.dataset.otp || "";
  const otpTime = rootElement.dataset.otptime || "";
  const page = document.body.dataset.page; // get the page type
  const root = ReactDOM.createRoot(rootElement);
    console.log("page",page);
  root.render(
    <React.StrictMode>
      {page === "signup" && (
        <>
          <SignupButtonBehaviour />
          <TogglePasswordBehaviour />
          <ExcludeBehaviour />
        </>
      )}

      {page === "login" && (
        <>
          <TogglePasswordBehaviour />
          <ExcludeBehaviour />
        </>
      )}
      {page === "complete-account-password" && (
        <>
          <TogglePasswordBehaviour />
          <ExcludeBehaviour />
        </>
      )}
      {page === "set_password" && (
        <>
          <TogglePasswordBehaviour />
          <ExcludeBehaviour />
        </>
      )}
      {page === "role" && (
        <>
          <RoleHighlightBehaviour />
          <ExcludeBehaviour />
        </>
      )}
      {page === "steppers" && (
        <>
          <SteppersBehaviour />
          <ExcludeBehaviour />
        </>
      )}
      {page === "otp" && (
        <>
         <OTPBehaviour debugOtp={otp} otpCreatedAt={otpTime}/>
          <ExcludeBehaviour />
        </>
      )}

      {page === "payment" && <PaymentForm />}

      {page === "exclude" && <ExcludeBehaviour />}
      {(page === "chatbot" || document.getElementById("exampleModalCenter")) && <Chatbot />}


    </React.StrictMode>
  );
}
//if (rootElement) {
//
//  const otp = rootElement.dataset.otp || "";
//  const otpTime = rootElement.dataset.otptime || "";
//
//  const root = ReactDOM.createRoot(rootElement);
//
//  root.render(
//    <React.StrictMode>
//      <Chatbot />
//      <Signup />
//      <TogglePasswordBehaviour />
//      <SignupButtonBehaviour />
//      <RoleHighlightBehaviour />
//      <OTPBehaviour debugOtp={otp} otpCreatedAt={otpTime} />
//      <SteppersBehaviour />
//      <PaymentForm />
//    </React.StrictMode>
//  );
//}
